/* KCPC — PPCOD_ELIGIBLE cart attribute for GoKwik KwikFlows.
   Yes = every cart item is ready stock -> Partial COD allowed
   No  = at least one pre-book / OOS item -> prepaid only

   Sep 2026 patch (Buy Now fix, per GoKwik Option 2):
   1. Buy Now now reads the flag FRESH at click time instead of a
      page-load cache, and always writes the attribute via cart/update.js
      before calling GoKwik's onBuyNowClick.
   2. The section fetch now carries the currently selected variant id,
      so switching size/colour gives the correct flag.
   3. The button wrap is refreshed on every click, so it works even if
      GoKwik's SDK loads late.
   Add to Cart behaviour is unchanged.
*/
(function () {
  'use strict';

  var nativeFetch = window.fetch && window.fetch.bind(window);
  if (!nativeFetch) return;

  var SECTION_ID = 'kcpc-ppcod';
  var ATTR_KEY = 'PPCOD_ELIGIBLE';
  var pending = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Which variant is the customer actually looking at right now?
     Priority: ?variant= in the URL, then the product form's hidden id. */
  function currentVariantId() {
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl) return fromUrl;
    } catch (e) {}
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return null;
  }

  function sectionUrl() {
    var path = window.location.pathname || root();
    var url = path + '?section_id=' + SECTION_ID + '&t=' + Date.now();
    var variant = currentVariantId();
    if (variant) url += '&variant=' + encodeURIComponent(variant);
    return url;
  }

  function readFlag() {
    return nativeFetch(sectionUrl(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('section fetch ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.getElementById('kcpc-ppcod-data');
        if (!node) throw new Error('kcpc-ppcod-data node missing');
        return JSON.parse(node.textContent);
      });
  }

  function writeFlag(value) {
    var attributes = {};
    attributes[ATTR_KEY] = value;
    /* cart/update.js MERGES attributes — other keys (AppHero, Flable,
       campaign tracking) are preserved. Verified on store, Sep 2026. */
    return nativeFetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update.js ' + r.status);
      return r.json();
    });
  }

  /* isBuyNow = true when called from the Buy Now button, where the PDP
     item is not in the cart yet and pdp_flag must be taken into account. */
  function sync(isBuyNow) {
    if (pending && !isBuyNow) return pending;

    var run = readFlag()
      .then(function (data) {
        var value;

        if (isBuyNow) {
          /* Take the stricter of the cart and the selected variant.
             Either one being pre-book / low stock means prepaid only. */
          if (data.flag === 'No' || data.pdp_flag === 'No') {
            value = 'No';
          } else if (data.pdp_flag === 'Yes') {
            value = 'Yes';
          } else if (data.item_count > 0) {
            value = data.flag;
          } else {
            /* No PDP context and an empty cart — nothing to decide on. */
            return null;
          }
        } else {
          if (data.item_count === 0) return null;
          value = data.flag;
        }

        if (data.current === value) return value;
        return writeFlag(value).then(function () { return value; });
      })
      .catch(function (e) {
        /* Never block the sale. Worst case GoKwik falls back to prepaid. */
        if (window.console) console.error('[PPCOD]', e);
        return null;
      })
      .then(function (v) { pending = null; return v; });

    pending = run;
    return run;
  }

  window.kcpcPPCODSync = sync;

  /* 1. On page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }

  /* 2. After every cart mutation (fetch + XHR) */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var chainedFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (url && url.url) url = url.url;
    var isCartWrite = typeof url === 'string' && CART_WRITE.test(url);
    var p = chainedFetch.apply(this, arguments);
    if (isCartWrite && p && p.then) {
      p.then(function () { setTimeout(function () { sync(); }, 80); }).catch(function () {});
    }
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kcpcCartWrite = typeof url === 'string' && CART_WRITE.test(url);
    return xhrOpen.apply(this, arguments);
  };
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__kcpcCartWrite) {
      this.addEventListener('load', function () {
        setTimeout(function () { sync(); }, 80);
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* 3. Hold checkout until the attribute is written.
     GoKwik buttons use inline onclick="onCheckoutClick(this)" /
     "onBuyNowClick(this)", which resolve against window at click time,
     so wrapping the globals is safe. */
  function wrapCheckout(name, isBuyNow) {
    var original = window[name];
    if (typeof original !== 'function' || original.__kcpcWrapped) return;
    function wrapped() {
      var ctx = this;
      var args = arguments;
      sync(isBuyNow).then(function () { original.apply(ctx, args); });
    }
    wrapped.__kcpcWrapped = true;
    window[name] = wrapped;
  }

  function wrapBoth() {
    wrapCheckout('onCheckoutClick', false);
    wrapCheckout('onBuyNowClick', true);
  }

  var tries = 0;
  var timer = setInterval(function () {
    wrapBoth();
    tries++;
    if (tries > 60) clearInterval(timer);
  }, 250);

  window.addEventListener('gokwikLoaded', wrapBoth);

  /* Safety net: re-wrap at the moment of any click, in the capture phase,
     which runs before the inline onclick. Covers a late-loading SDK or a
     global that gets redefined after our polling window closes. */
  document.addEventListener('click', wrapBoth, true);
})();
